import {ReferenceDefinitionDto} from "../../../../../common/apis/stereotype/ReferenceDefinitionDto";
import {UUIDUtils} from "../../../../../common/UUIDUtils";
import {UiReferenceField} from "./model/UiReferenceField";

export class UiReferenceFieldFactory {

    buildUiReferenceField(referenceDefinition: ReferenceDefinitionDto): UiReferenceField {
        if (referenceDefinition.multiple) {
            return this.buildSmartReferenceListField(referenceDefinition);
        } else {
            return this.buildSmartReferenceSelectField(referenceDefinition);
        }
    }

    private buildSmartReferenceListField(referenceDefinition: ReferenceDefinitionDto): UiReferenceField {
        return {
            id: UUIDUtils.randomUUID(),
            componentType: "SmartReferenceListField",
            referenceDefinitionId: referenceDefinition.id,
        };
    }

    private buildSmartReferenceSelectField(referenceDefinition: ReferenceDefinitionDto): UiReferenceField {
        return {
            id: UUIDUtils.randomUUID(),
            componentType: "SmartReferenceSelectField",
            referenceDefinitionId: referenceDefinition.id,
        };
    }
}